import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  ViewContainerRef,
  ComponentRef,
  inject,
} from '@angular/core';
import { Overlay, OverlayRef, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { TooltipOverlayComponent } from './tooltipOverlay/tooltipOverlay.component';
import { ComponentPortal } from '@angular/cdk/portal';

@Directive({
  selector: '[markdownTooltip]',
})
export class MarkdownTooltipDirective {
  @Input('markdownTooltip') htmlContent = '';

  private overlayRef: OverlayRef | null = null;

  private overlay = inject(Overlay);
  private elementRef = inject(ElementRef<HTMLElement>);
  private viewContainerRef = inject(ViewContainerRef);
  private positionBuilder = inject(OverlayPositionBuilder);

  @HostListener('mouseenter')
  show() {
    if (this.overlayRef) return;

    const positionStrategy = this.positionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'center',
          overlayY: 'top',
          offsetY: 8,
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    const tooltipPortal = new ComponentPortal(TooltipOverlayComponent, this.viewContainerRef);
    const tooltipRef: ComponentRef<TooltipOverlayComponent> = this.overlayRef.attach(tooltipPortal);
    tooltipRef.instance.html =  "<div>" + this.htmlContent + "</div>";
  }

  @HostListener('mouseleave')
  hide() {
    this.overlayRef?.detach();
    this.overlayRef = null;
  }
}
